import * as React from "react";

const SvgChevronDown = props => <svg width="100%" height="100%" viewBox="0 0 9 5" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9 0.951417L7.9425 -4.73097e-08L4.5 3.09042L1.0575 -3.55326e-07L-4.15878e-08 0.951417L4.5 5L9 0.951417Z" fill="currentColor" /></svg>;

export default SvgChevronDown;